<template>
  <ModalPermissionBrowser
    v-if="showModalPermissionBrowser"
    :showModalPermissionBrowser="showModalPermissionBrowser"
    @onCloseModalPermissionBrowser="closeModalPermissionBrowser"
  />
  <section class="md:px-14 my-10 flex flex-col justify-start w-full">
    <div
      class="grid grid-cols-12 gap-5 bg-white p-5 md:p-8 rounded-md shadow-md"
    >
      <div class="col-span-12">
        <div class="flex justify-between items-center">
          <h2 class="text-lg md:text-2xl">
            {{
              $t("labels.generic", {
                pt: "Detecção de atenção",
                en: "Detect attention",
              })
            }}
          </h2>
        </div>
      </div>
      <div class="col-span-12 flex items-center gap-8 flex-wrap">
        <div
          v-for="(item, i) in switchers"
          :key="i"
          class="flex gap-8 items-center"
        >
          <div class="flex gap-5">
            <p class="mb-2">{{ item.name }}</p>
            <InputSwitch v-model="item.selected" @change="item.action(i)" />
          </div>
        </div>
        <div class="col-span-12 md:col-span-6 flex items-center gap-3">
          <v-icon
            name="hi-information-circle"
            :scale="2"
            class="text-gray-400"
          />
          <p class="text-gray-400 text-sm w-72">
            {{
              $t("labels.generic", {
                pt: "Ao desativar a detecção de atenção, você pode perder o foco nos seus estudos.",
                en: "By turning attention detection off, you may lose focus on your studies.",
              })
            }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { UsersRest } from "@/services/rest/users.rest";
import { MediaPermissionsError } from "mic-check";
import { defineComponent } from "vue";
import { EditUserService } from "../edit-user.service";

export default defineComponent({
  name: "userResources",
  computed: {
    rest(): UsersRest {
      return new UsersRest();
    },
    service(): EditUserService {
      return new EditUserService();
    },
  },
  data() {
    return {
      switchers: [] as any,
      loading: false as boolean,
      showModalPermissionBrowser: false as boolean,
    };
  },
  mounted() {
    this.getConfigs();
  },
  methods: {
    getSwitchers({ attention }): void {
      this.switchers = [
        {
          name: this.$t("labels.generic", {
            pt: "Ativar detecção",
            en: "Active detection",
          }),
          action: (index) => this.changeSubmit(index),
          selected: attention,
        },
        // {
        //   name: this.$t("labels.generic", {
        //     pt: "Usar Speech to Text",
        //     en: "Use Speech to Text",
        //   }),
        //   selected: false,
        // },
        // {
        //   name: this.$t("labels.generic", {
        //     pt: "Mutar Homero",
        //     en: "Mute Homero",
        //   }),
        //   selected: false,
        // },
      ];
    },
    changeSubmit(index: number): void {
      const data = { attentionEnabled: this.switchers[index].selected };
      if (data.attentionEnabled){
        this.openModalPermissionBrowser()
      }
      this.rest.updateUserConfigurations(data).subscribe({
        next: (response) => {
          this.service.saveConfigs(response);
        },
      });
    },
    getConfigs(): void {
      this.service.configs.subscribe({
        next: (response) => {
          const { attentionEnabled } = response;
          this.getSwitchers({ attention: attentionEnabled });
        },
      });
      this.service.getUserConfigurations();
    },
    closeModalPermissionBrowser(): void {
      this.showModalPermissionBrowser = false;
    },
    async openModalPermissionBrowser(): Promise<void> {
      await navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then((e) => {
          this.showModalPermissionBrowser = false;
        })
        .catch((error: MediaPermissionsError) => {
          this.showModalPermissionBrowser = true;
        });
    },
  },
});
</script>
